/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cannot_Access_This_RouteInputs */

const en_cannot_access_this_route = /** @type {(inputs: Cannot_Access_This_RouteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot access this route`)
};

const nl_cannot_access_this_route = /** @type {(inputs: Cannot_Access_This_RouteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan deze route niet openen`)
};

/**
* | output |
* | --- |
* | "Cannot access this route" |
*
* @param {Cannot_Access_This_RouteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const cannot_access_this_route = /** @type {((inputs?: Cannot_Access_This_RouteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cannot_Access_This_RouteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_cannot_access_this_route(inputs)
	return en_cannot_access_this_route(inputs)
});